import useApiQuery from '@hooks/useApiQuery';
import { AuditLog } from '@src/types/Audit-Logs';
import { PaginatedResponse } from '@src/types/pagination/PaginatedResponse';
import QueryKeys from '@src/constants/queryKeys';

interface AuditLogSearchParams {
  from: string;
  to: string;
  page: number;
  count: number;
  username?: string;
  email?: string;
  url?: string;
  httpMethod?: string;
}

export default function useAuditLogsQuery(params: AuditLogSearchParams) {
  const query = useApiQuery<PaginatedResponse<AuditLog>>({
    queryKey: [QueryKeys.auditLogs, JSON.stringify(params)],
    apiPath: '/audit-logs/search',
    method: 'POST',
    useV2API: true,
    body: params,
  });

  return {
    ...query,
    rows: query.data?.paginatedResults ?? [],
    totalCount: query.data?.totalCount ?? 0,
  };
}
